import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { supabase } from './lib/supabase'
import Auth from './pages/Auth'
import Home from './pages/Home'
import Admin from './pages/Admin'
import ShareProduct from './pages/ShareProduct'
import ApiDocs from './pages/ApiDocs'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import SolarpunkDecorations from './components/SolarpunkDecorations'

function App() {
  const [user, setUser] = useState(null)
  const [isAdmin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      setUser(session?.user ?? null)
      setLoading(false)
    }

    getSession()

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
    })

    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user) {
        const { data, error } = await supabase
          .from('tobacco_admin_roles')
          .select('*')
          .eq('user_id', user.id)
          .single()

        setIsAdmin(!!data && !error)
      } else {
        setIsAdmin(false)
      }
    }

    checkAdminStatus()
  }, [user])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg shadow-green-300/40 animate-pulse">
            <div className="w-8 h-8 border-t-2 border-white rounded-full animate-spin"></div>
          </div>
          <p className="text-green-600 font-medium">加载中...</p>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <div className="min-h-screen relative flex flex-col">
        <SolarpunkDecorations />
        <AppContent user={user} isAdmin={isAdmin} />
      </div>
    </Router>
  )
}

function AppContent({ user, isAdmin }) {
  const location = useLocation()
  const isSharePage = location.pathname.startsWith('/share/')

  return (
    <div className="flex-1 flex flex-col">
      {!isSharePage && <Navbar user={user} isAdmin={isAdmin} />}
      <main className="flex-1">
        <Routes>
          <Route 
            path="/auth" 
            element={user ? <Navigate to="/" /> : <Auth />} 
          />
          <Route 
            path="/" 
            element={<Home user={user} />} 
          />
          <Route 
            path="/share/:id" 
            element={<ShareProduct />} 
          />
          <Route 
            path="/api" 
            element={<ApiDocs />} 
          />
          <Route 
            path="/admin" 
            element={user && isAdmin ? <Admin user={user} /> : <Navigate to="/" />} 
          />
        </Routes>
      </main>
      {!isSharePage && <Footer />}
    </div>
  )
}

export default App
